$(document).ready(function(){
    var isMecan         =  $("input[name='isMecan']").val()
    var isDepan         =  $("input[name='isDepan']").val()
    var fgCost          =  $("input[name='fgCost']").val()
    var totalCost       =  $("input[name='totalCost']").val()
    var depannageCost   =  $("input[name='depannageCost']").val()
    var mecaniqueCost   =  $("input[name='mecaniqueCost']").val()
    var mecaniqueCostHT = $("input[name='mecaniqueCostHT']").val()
    var tvafgCost       =  $("input[name='tvafgCost']").val()

    $("input[name='fgCost']").on("keyup change", function() {
        fgCost =  $("input[name='fgCost']").val()
        recalculatePrice(isDepan,isMecan,fgCost,totalCost,depannageCost,mecaniqueCost,mecaniqueCostHT,tvafgCost);
    });

    $("input[name='mecaniqueCostHT']").on("keyup change", function() {
        mecaniqueCostHT =  $("input[name='mecaniqueCostHT']").val()
        recalculatePrice(isDepan,isMecan,fgCost,totalCost,depannageCost,mecaniqueCost,mecaniqueCostHT,tvafgCost);
    });

    $("input[name='depannageCost']").on("keyup change", function() {
        depannageCost =  $("input[name='depannageCost']").val()
        recalculatePrice(isDepan,isMecan,fgCost,totalCost,depannageCost,mecaniqueCost,mecaniqueCostHT,tvafgCost);
    });
});

function recalculatePrice(isDepan,isMecan,fgCost,totalCost,depannageCost,mecaniqueCost,mecaniqueCostHT,tvafgCost) {
    if(isMecan.includes('1')) {
        $("input[name='fgCost']").val(fgCost)
        fgCost = $("input[name='fgCost']").val()
        $("input[name='tvafgCost']").val(((parseFloat(fgCost) * 20)/100).toFixed(2))
        tvafgCost = $("input[name='tvafgCost']").val()
        $("input[name='mecaniqueCostHT']").val(mecaniqueCostHT)
        mecaniqueCostHT = $("input[name='mecaniqueCostHT']").val()
        $("input[name='mecaniqueCost']").val((parseFloat(mecaniqueCostHT) + parseFloat(tvafgCost)).toFixed(2))
        mecaniqueCost = $("input[name='mecaniqueCost']").val()
    }
    if(isDepan.includes('1')) {
        $("input[name='depannageCost']").val(depannageCost)
        depannageCost   = $("input[name='depannageCost']").val()
    }

    if(isMecan.includes('1')  && isDepan.includes('1')) {
        $("input[name='totalCost']").val((parseFloat(mecaniqueCost) + parseFloat(depannageCost)).toFixed(2))
    }
    if(isMecan.includes('1') && isDepan.includes('0')) {
        $("input[name='totalCost']").val(parseFloat(mecaniqueCost).toFixed(2))
    }
    if(isMecan.includes('0') && isDepan.includes('1')) {
        $("input[name='totalCost']").val(parseFloat(depannageCost).toFixed(2))
    }

}
